<script setup>
import LImpact from "@/components/layout/LImpact.vue";
import ImpactRoundedImg from "@/components/impact/ImpactRoundedImg.vue";
</script>

<template>
  <LImpact>
    <template #title> Manufacturing & Industry </template>
    <template #description>
      Quantum technologies could revolutionize industry by enhancing production processes with greater precision and efficiency. Innovations in material science, driven by quantum simulations, will lead to improved consumer products, electronics, and medical devices with superior performance. Additionally, quantum approaches to energy supply and optimization could help reduce costs and environmental impact, making energy cleaner and more affordable. This, in turn, will further support the sustainability of industrial operations.
    </template>
    <template #image>
      <ImpactRoundedImg category-name="Manufacturing & Industry" />
    </template>
  </LImpact>
</template>

<style scoped></style>
